var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"show-tag-columns":"","show-tag-columns2":"","show-tag-filter":"","show-tag-config":"","columns":_vm.columns,"list":_vm.list,"showSearchbox":_vm.showSearchbox,"export-data-options":_vm.exportDataOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }